module.exports = __webpack_public_path__ + "img/马瑞利.png";